export const lockContentHeight = (
  parentElement: HTMLElement,
  onLock: CallableFunction
) => {
  requestAnimationFrame(() => {
    const refinementListContent =
      parentElement.querySelector<HTMLElement>('.e-RefinementList')

    const height = refinementListContent?.offsetHeight
    if (height) {
      refinementListContent.style.minHeight = `${height}px`
      onLock()
    }
  })
}
